import { PageContainer } from '@components'
import { Contributor } from '@views/Contributor'
import { useParams } from 'react-router'
import { useEffect } from 'react'
import { store } from '@store'

const ContributorPage = () => {
  const { id } = useParams()

  const hitsFiltered = store.use.hitsFiltered()
  const getHitsAchievementAction = store.use.getHitsAchievementAction().call
  const isLoadingGetHitsAchievementAction =
    store.use.getHitsAchievementAction().status === 'LOADING'

  useEffect(() => {
    getHitsAchievementAction({ idProject: id, body: { model: {} } })
  }, [id])

  return (
    <PageContainer>
      <Contributor hitsAchievement={hitsFiltered} isLoading={isLoadingGetHitsAchievementAction} />
    </PageContainer>
  )
}
export default ContributorPage
